import { TaxRate } from '@/types/taxRate';

const formatYen = (value: number): string => value.toLocaleString('ja-JP');

export const formatMagazinePrice = (price: number | null | undefined, taxRate?: TaxRate): string => {
    // 販売前・価格未設定
    if (price == null) {
        return '';
    }

    // 税率が未取得の場合（保険）
    if (!taxRate) {
        return `定価：${formatYen(price)}円`;
    }

    const rate = taxRate.tax_rate;

    // 非課税
    if (rate === 0) {
        return `定価：${formatYen(price)}円（非課税）`;
    }

    const taxAmount = Math.floor(price * rate);
    const priceWithTax = price + taxAmount;
    const taxPercent = Math.round(rate * 100);

    return `定価：${formatYen(priceWithTax)}円（本体${formatYen(price)}円+税${taxPercent}％）`;
};
